// extracted by mini-css-extract-plugin
module.exports = {"kit-options__disclaimer":"KitOptions_kit-options__disclaimer__YhqoW"};